import './App.css';
import ProductTable from "./page3";

function App() {
  return (
    <ProductTable>

    </ProductTable>
  );
}

export default App;
